function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarSpecialFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 5h-3V3h-2v2H10V3H8v2H5a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7H5V7h3v3h2V7h12v3h2V7h3v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27H5V16H3v11a2 2 0 002 2h22a2 2 0 002-2V16h-2v11z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.728 22.66L14.395 24a51.614 51.614 0 001.544-2.632l1.49 2.552 1.688-1.156a25.469 25.469 0 00-.629-.767l-1.324-1.545c1.074-.183 2.02-.37 2.836-.56l-.585-2.072c-.559.221-1.17.488-1.832.8-.485.237-.801.386-.948.447.198-1.488.297-2.51.297-3.067h-1.964c0 .786.089 1.8.265 3.044a16.665 16.665 0 00-2.582-1.339L12 19.72c.199.076.61.194 1.236.354.868.222 1.394.348 1.578.378l-.43.435a28.583 28.583 0 00-1.656 1.774z",
    fill: props.color
  }));
}

export default SvgIconCalendarSpecialFilled;